import React from 'react';
import { connect } from 'react-redux';
import axios from 'axios';
import moment from 'moment';
import { REQUEST_URL } from '../config/urls';

// Etapas que o formando acompanha. O contrato tem outros procedimentos
// internos (bureau, start, pos vendas), que ficam so para a Alpha.
const ETAPAS_VISIVEIS = [
  'Cadastro de formandos',
  'Briefing',
  'Roteiro do Convite',
  'Publicação da Capa Dura',
  'Publicação do Convite',
  'Revisão da Capa Dura',
  'Republicação da Capa Dura',
  'Aprovação Final da Capa Dura',
  'Revisão do Convite',
  'Envio das Fotos',
  'Conferência e Análise das Fotos',
  'Finalização da Etapa Envio das Fotos',
  'Republicação do Convite',
  'Atendimento Designer Online',
  'Aprovação Final da Personalização',
  'Início Sistema de Personalização',
  'Aprovação Final/Qtd/ Endereço',
  'Finalização do Sistema de Personalização',
  'Entrega dos Convites',
];

// Os nomes vem do sistema com acento, caixa e espacos irregulares:
// comparamos sempre pela versao simplificada.
const simplificar = function(nome) {
  return String(nome || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/\s*\/\s*/g, '/')
    .replace(/\s+/g, ' ')
    .trim();
};

const ETAPAS_VISIVEIS_SIMPLES = ETAPAS_VISIVEIS.map(simplificar);

const etapaVisivel = function(proc) {
  return ETAPAS_VISIVEIS_SIMPLES.indexOf(simplificar(proc.procedimento)) !== -1;
};

class Cronograma extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      dadosContrato: null,
      procedimentos: [],
      refeito: null,
      erro: null,
      jaCarregou: false,
    };
    this._isMounted = false;
  }

  componentDidMount() {
    this._isMounted = true;
    if (!this.props.carregando && this.props.contrato && this.props.contrato.numero) {
      this._buscar(this.props.contrato.numero);
    }
  }

  componentDidUpdate(prevProps) {
    const numero = this.props.contrato && this.props.contrato.numero;
    if (prevProps.carregando && !this.props.carregando && numero && !this.state.jaCarregou) {
      this._buscar(numero);
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  _buscar(numero) {
    if (!this._isMounted || this.state.loading) return;
    this.setState({ loading: true, jaCarregou: true });
    axios.get(REQUEST_URL + '/dashboard/contrato/timeline', {
      params: { codigo: numero },
    }).then((response) => {
      if (!this._isMounted) return;
      this.setState({
        dadosContrato: response.data.contrato,
        procedimentos: (response.data.procedimentos || []).filter(etapaVisivel),
        refeito: response.data.refeito || null,
        loading: false,
      });
    }).catch((err) => {
      if (!this._isMounted) return;
      console.error('[Cronograma]', err.message);
      this.setState({ loading: false, erro: 'Não foi possível carregar o cronograma.' });
    });
  }

  render() {
    const { loading, dadosContrato, procedimentos, erro } = this.state;

    const statusInfo = function(proc) {
      const s = (proc.Status || '').toLowerCase();
      if (proc.atrasado)                              return { cor: '#b91c1c', bg: '#fee2e2', label: 'Atrasado' };
      if (s === 'concluido')                          return { cor: '#15803d', bg: '#dcfce7', label: 'Concluído' };
      if (s === 'execução' || s === 'execucao')       return { cor: '#1d4ed8', bg: '#dbeafe', label: 'Em Execução' };
      return                                                 { cor: '#64748b', bg: '#f1f5f9', label: 'Aguardando' };
    };

    const thStyle = {
      padding: '5px 8px', fontSize: 11, fontWeight: 700,
      color: '#475569', textAlign: 'left', borderBottom: '2px solid #cbd5e1',
      background: '#f8fafc', whiteSpace: 'nowrap',
    };

    const tdStyle = {
      padding: '4px 8px', fontSize: 11, color: '#1e293b',
      borderBottom: '1px solid #f1f5f9', verticalAlign: 'middle',
    };

    const renderCorpo = () => {
      if (loading || this.props.carregando) {
        return (
          <div style={{ padding: 32, textAlign: 'center', color: '#94a3b8', fontSize: 12 }}>
            Carregando cronograma...
          </div>
        );
      }
      if (erro) {
        return <div style={{ padding: 32, textAlign: 'center', color: '#dc2626', fontSize: 12 }}>{erro}</div>;
      }
      if (!dadosContrato) {
        return <div style={{ padding: 32, textAlign: 'center', color: '#94a3b8', fontSize: 12 }}>Nenhum cronograma encontrado.</div>;
      }

      return (
        <div>
          {/* Cabeçalho estilo documento */}
          <div style={{ padding: '10px 16px 8px', borderBottom: '2px solid #e2e8f0' }}>
            <div style={{ display: 'flex', alignItems: 'baseline', gap: 10, marginBottom: 6 }}>
              <span style={{ fontSize: 13, fontWeight: 700, color: '#0f172a' }}>
                Nº Cronograma: {dadosContrato.contrato}
              </span>
            </div>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 16, fontSize: 11, color: '#475569' }}>
              <span><b>Responsável:</b> {dadosContrato.RegistradoPor || '-'}</span>
              <span><b>Dt. Entrega:</b> {dadosContrato.dt_entrega ? moment(dadosContrato.dt_entrega).format('DD/MM/YYYY') : '-'}</span>
              <span><b>Dt. Formatura:</b> {dadosContrato.dt_formatura ? moment(dadosContrato.dt_formatura).format('DD/MM/YYYY') : '-'}</span>
            </div>
          </div>

          {/* Tabela compacta */}
          <div style={{ padding: '0 16px 12px' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', tableLayout: 'auto' }}>
              <thead>
                <tr>
                  <th style={thStyle}>Procedimento</th>
                  <th style={{ ...thStyle, textAlign: 'center' }}>Responsável</th>
                  <th style={{ ...thStyle, textAlign: 'center' }}>Prazo para Conclusão</th>
                  <th style={{ ...thStyle, textAlign: 'center' }}>Dt. Conclusão</th>
                  <th style={{ ...thStyle, textAlign: 'center' }}>Status</th>
                </tr>
              </thead>
              <tbody>
                {procedimentos.length === 0 ? (
                  <tr>
                    <td colSpan={5} style={{ ...tdStyle, textAlign: 'center', color: '#94a3b8' }}>
                      Nenhuma etapa cadastrada.
                    </td>
                  </tr>
                ) : (
                  procedimentos.map(function(proc, i) {
                    const info = statusInfo(proc);
                    const rowBg = i % 2 === 0 ? '#ffffff' : '#f8fafc';
                    return (
                      <tr key={i} style={{ background: rowBg }}>
                        <td style={{ ...tdStyle, fontWeight: proc.atrasado ? 700 : 400, color: proc.atrasado ? '#b91c1c' : '#1e293b' }}>
                          {proc.procedimento}
                        </td>
                        <td style={{ ...tdStyle, textAlign: 'center', color: '#475569' }}>
                          {proc.Resp || '-'}
                        </td>
                        <td style={{ ...tdStyle, textAlign: 'center', color: '#475569', whiteSpace: 'nowrap' }}>
                          {proc.dtfim ? moment(proc.dtfim).format('DD/MM/YYYY') : '-'}
                        </td>
                        <td style={{ ...tdStyle, textAlign: 'center', color: '#475569', whiteSpace: 'nowrap' }}>
                          {proc.dtconclusao ? moment(proc.dtconclusao).format('DD/MM/YYYY') : '-'}
                        </td>
                        <td style={{ ...tdStyle, textAlign: 'center' }}>
                          <span style={{
                            display: 'inline-block',
                            fontSize: 10, fontWeight: 700,
                            padding: '1px 8px', borderRadius: 20,
                            background: info.bg, color: info.cor,
                            whiteSpace: 'nowrap',
                          }}>
                            {info.label}
                          </span>
                        </td>
                      </tr>
                    );
                  })
                )}
              </tbody>
            </table>
          </div>
        </div>
      );
    };

    return (
      <section className='content'>
        <div className='row'>
          <div className='col-xs-12 col-md-10 col-md-offset-1 col-lg-8 col-lg-offset-2'>
            <div className='box' style={{ boxShadow: '0 1px 4px rgba(0,0,0,0.08)' }}>
              <div className='box-header with-border' style={{ padding: '8px 16px' }}>
                <h3 className='box-title' style={{ margin: 0, fontSize: 14, fontWeight: 700 }}>Cronograma</h3>
              </div>
              <div className='box-body' style={{ padding: 0 }}>
                {renderCorpo()}
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

const mapStateToProps = function(state) {
  return {
    contrato: state.contrato.especifico,
    carregando: state.contrato.carregando,
  };
};

export default connect(mapStateToProps)(Cronograma);
